import { TYPE, MESSAGE, URL as PathUrl } from "../constant";
import { errorMessage } from '../redux/errorState';
import { store } from '../components/provider/ReduxProvider';
import { setLoadingAction } from "../redux/loading";
import { appKillFunc } from "../utils/utilityEtc";


async function fetchWithTimeout(resource, options = {}) {
  const { timeout = 30000 } = options;

  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);
  const response = await window.fetch(resource, {
    ...options,
    signal: controller.signal
  });
  clearTimeout(id);
  return response;
}

const http = {

  METHOD : {
    GET : 'GET',
    POST : 'POST',
    PUT : 'PUT',
    DELETE : 'DELETE'
  },

  TYPE : {
    LOGIN : 'login',
    FILE_UPLOAD : 'fileUpload',
    SELVAS : 'selvas',
    XML : 'xml',
    TTS : 'tts'
  },

  request : async ( option ) => {
    const locale = localStorage.getItem('locale');
    const url = option.url;
    const data = option.data;
    const idx = url.indexOf('/language/');
    if (locale && idx > -1) {
      const nowLocale = url.substring(idx, (idx + 13));
      option.url = option.url.replace(nowLocale, `/language/${locale}/`);
    } else if (locale && data?.langCd) {
      option.data.langCd = locale;
    }

    // typeof AbortController === "undefined"
    const fetch = fetchWithTimeout(option.url, {
      // signal: Timeout(3).signal,
      ...getMethod(option),
      ...getHeaders(option),
      ...getData(option),
      ...getCredentials(option),
      retries: option.retries,
    });

    switch ( option.type ) {
      case http.TYPE.XML :
        await dispatchXMLData( fetch, option );
        break;
      case http.TYPE.TTS :
        dispatchTTSData( fetch, option );
        break;
      default :
        await dispatchJSONData( fetch, option );
    }

  }

};

const getMethod = option => ( { method : option.method || http.METHOD.GET } );

const getHeaders = ( option ) => {

  const accessToken = localStorage.getItem( 'access.token' );

  let headers = {};
  
  switch ( option.type ) {
    case http.TYPE.TTS :
      if ( process.env.REACT_APP_ENV === 'production' ) {
        headers = {
          'X-NCP-APIGW-API-KEY-ID' : 'vpc0vty1rx',
          'X-NCP-APIGW-API-KEY' : 'gS9BRU2nSyfxS6OhOXzIrrYdXWXxM6wJ7wIgxoT4'
        };
      } else {
        headers = {
          'X-NCP-APIGW-API-KEY-ID' : 'tjzy0nr5k2',
          'X-NCP-APIGW-API-KEY' : 'Gp3v9c2CAf0naI6XZf5ZeurCB4PEJd0AbtQQIMsg'
        };
      }
      break;
    default :
      switch ( option.type ) {
        case http.TYPE.LOGIN :
        case http.TYPE.SELVAS :
        case http.TYPE.XML :
          break;
        default :
          headers = { Authorization : `Bearer ${ accessToken }` };
      }
      switch ( option.method ) {
        case http.METHOD.POST :
        case http.METHOD.PUT :
        case http.METHOD.DELETE :
          if ( http.TYPE.FILE_UPLOAD !== option.type ) {
            headers = {
              ...headers,
              'Content-Type' : 'application/json'
            };
          }
          break;
      }
  }

  if ( Object.keys( headers ).length ) {
    headers = { headers };
  }

  return headers;

};

const getData = ( option ) => {

  let data = {};

  if ( option.data ) {
    switch ( option.type ) {
      case http.TYPE.FILE_UPLOAD :
      case http.TYPE.TTS :
        data = new FormData();
        for ( let i in option.data ) {
          data.append( i, option.data[ i ] );
        }
        break;
      default :
        data = JSON.stringify( option.data );
    }
    data = { body : data };
  }

  return data;

};

const getCredentials = ( option ) => {

  switch ( option.type ) {
    case http.TYPE.XML :
    case http.TYPE.TTS :
    case http.TYPE.SELVAS :
      return {};
    default:
      return { credentials : 'include' };
  }

};

const dispatchJSONData = async (fetch, option) => {

  await fetch
    .then(
      async (response) => {
        
        switch ( response.status ) {
          case 404:
            store.dispatch(errorMessage("E404", MESSAGE.INTERNAL_SERVER_ERROR));
            break;
          case 500:
            // upload_history API 500 예외처리 (추후 OCR API에서 status code 수정 요망)
            if (option.url.indexOf('/api/upload_history') > -1) {
              return response.json()
            };
            
            store.dispatch(errorMessage("E500", MESSAGE.INTERNAL_SERVER_ERROR));
            break;
          case 502:
          case 503:
            option.error && option.error( response );
            return false;
          default:
            var xAuthMember = response.headers.get('X-Auth-Member');
            const state = store.getState();
            const info = state.user.info;
            
            const channelCode = info?.channelCode ? info.channelCode : localStorage.getItem('channel.code')
            // 중복 로그인, 세션만료
            if ( xAuthMember === TYPE.LOGIN.DUPLICATE || xAuthMember === TYPE.LOGIN.EXPIRES ) {
              const e = {
                type: "xAuthMember",
                response
              }
              if (process.env.REACT_APP_ENV === 'local') {
                // 현재 http로 들어가는 local은 DUP, EXP 테스트가 불가능
                return response.json();
              } else if (xAuthMember === TYPE.LOGIN.EXPIRES && channelCode === TYPE.CHANNEL.GLOBAL01) {
                // 게스트 로그인 개발 후 30분 로그아웃은 글로벌에서 제외
                return response.json();
              }
              throw e;
            }
            
            return response.json();
        }
      },
      async ( error ) => {
        store.dispatch(setLoadingAction({ isShowSpinner: false, spinnerType: '1' }));
        if (error.code === 20 && error.name === 'AbortError' && option.retries === 1) {
          
          const wait = () => {
            return new Promise(resolve => {
              document.getElementById('newtork_error_popup').style.display = ''
              document.getElementById('network_error_btn').addEventListener('click', () => resolve(true))
            });
          }

          let result = await wait()

          if (result) {
            document.getElementById('newtork_error_popup').style.display = 'none';
            return http.request({
              ...option,
            });
          }
        } else {
          option.error && option.error( error );
          return false;
        }
      }
    )
    .then(
      (data) => {
        // data = {
        //   code: 'S003003',
        //   msg: 'test'
        // }
        const state = store.getState();
        const info = state.user.info;
        switch ( data.code ) {
          case 'S000000' :
            option.success && option.success( data.data, 'S000000' );
            break;
          case 'S001005':
          case 'S002012':
            store.dispatch(errorMessage(data.code, null, null, info));
            option.error && option.error(data);
            break;
          case 'S000001':
          case 'S003001':
          case 'S003003':
          case 'E000021':
          case 'E000013':
          case 'E000022':
            store.dispatch(errorMessage(data.code, null, null, info));
            break;
          case 'E000018':
            /**
             * token 만료시 API에서 EXP가 오지 못하는 상황
             * state의 user 정보에서 entryType을 보고
             * 북패드, 스마트올일 경우는 앱 종료
             * 탈배드일 경우 자동로그인이 활성화 되어 있는 경우는 새로고침(자동 로그인)
             * 활성화 되어 있지 않은 경우는 로그인 Alert 노출 후 로그인 페이지
             */
            const state = store.getState();
            if (state.user.info.entryType === TYPE.ENTRY_TYPE.GM_APP) {
              const isAutoLoginChk = localStorage.getItem('mathpidLoginChk');
              if (isAutoLoginChk === 'Y') {
                window.location = PathUrl.SELECT_LEARNING
              } else {
                store.dispatch(errorMessage(data.code));
              }
            } else {
              store.dispatch(errorMessage(TYPE.LOGIN.EXPIRES));
            }
            
            break;
          default:
            store.dispatch(setLoadingAction({ isShowSpinner: false, spinnerType: '1' }));
            if ( 'ERR_SUCCESS' === data.hwrErrorCode?.code ) {
              option.success && option.success( data.candidates, 'ERR_SUCCESS' );
            } else {
              option.error && option.error(data);
            }
        }
      }
    )
    .catch(error => {
      store.dispatch(setLoadingAction({ isShowSpinner: false, spinnerType: '1' }));
      switch ( error.type ) {
        case "xAuthMember": // 중복 로그인, 30분동안 미사용
          var xAuthMember = error.response.headers.get('x-auth-member');
          if (store) {
            store.dispatch(errorMessage(xAuthMember));
          }
          break;
        default:
          if (error && error.code) {
            let msg = error.data.message ? error.data.message : error.msg;
            store.dispatch(errorMessage(error.code, msg));
          } else {
            if (error?.code) {
              store.dispatch(errorMessage("msg", error.data.message));
            } 
          }
          console.log("http error: ", error);
          break;
      }
    } );

};

const dispatchXMLData = async ( fetch, option ) => {
  await fetch
    .then(
      response => response.text(),
      ( error ) => {
        option.error && option.error( error );
        return false;
      }
    )
    .then(
      ( data ) => {
        const parser = new DOMParser();
        const convertedData = parser.parseFromString( data, 'text/xml' );
        option.success && option.success( convertedData )
      }
    );

};

const dispatchTTSData = ( fetch, option ) => {

  fetch
    .then(
      ( response ) => {
        const reader = response.body.getReader();
        return new ReadableStream( {
          start( controller ) {
            const pump = () => {
              return reader.read().then( ( { done, value } ) => {
                if ( done ) {
                  controller.close();
                  return;
                }
                controller.enqueue( value );
                return pump();
              } );
            };
            return pump();
          }
        } );
      }
    )
    .then( stream => new Response( stream ) )
    .then( response => response.blob() )
    .then( blob => URL.createObjectURL( blob ) )
    .then( url => option.success && option.success( url ) )
    .catch( error => option.error && option.error( error ) );

};

export default http;
